import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import Page from "components/Page";
import styles from "./ViewContract.module.scss";
import { useOfficeDetail } from "repositories/office-repository";
import {
  useContractTemplateById,
  getContractTemplatePdf,
} from "repositories/contract-repository";
import * as moment from "moment";
import PreviewPersonnelContract from "./components/PreviewPersonnelContract";
import PreviewAssociateContract from "./components/PreviewAssociateContract";
import Loader from "components/Loader";
import SignContractForm from "./components/SignContractForm";
import toast from "react-hot-toast";
import { b64toBlob, isMobileTab } from "utils";
import FileSaver from "file-saver";
import { decodeId, parseCalendarDateToLocalDate } from "utils";
import { addDataIntoContractArray } from "accountOwner/pages/NewEmploymentContract/components/AddContract";
import { useQueryClient } from "react-query";

function ViewContract({ history, match, location, t }) {
  let officeName = null;
  if (location.state && location.state.officeName) {
    officeName = location.state.officeName;
  }
  const officeId = match.params.officeId;
  const contractId = decodeId(match.params.contractId);
  const [signContract, setSignContract] = useState(false);
  const [pdfLoader, setPdfLoader] = useState(false);
  const [designationType, setDesignationType] = useState(2);
  const [contractFormDisplayData, setDisplayData] = useState([]);

  const [BasicDetails, setBasicDetails] = useState({
    contractId,
    IsSubmitted: false,
    Type: 2,
    Date: moment().toDate(),
    BusinessLegalName: officeName,
    Position: "",
    OfficeAddress: "",
    LengthOfEmployment: "",
    StartOfWorkDate: moment().toDate(),
    EndOfWorkDate: moment().add(1, "d").toDate(),
    EmployeeName: "",
    EmployeeAddress: "",
    Salary: "",
    ContractDetails: [],
  });

  const { isLoading: isLoadingOfficeDetail, data: officeDetail } =
    useOfficeDetail(decodeId(officeId));
  useEffect(() => {
    addDataIntoContractArray({
      BasicDetails,
      officeDetail,
      setDisplayData,
    });
    //eslint-disable-next-line
  }, [BasicDetails]);
  const {
    isLoading: isLoadingTemplate,
    data: contractTemplateData,
    error: contractTemplateError,
  } = useContractTemplateById(contractId);
    const queryClient = useQueryClient();
  
    useEffect(() => {
      return () => {
        queryClient.invalidateQueries(["/Contract/ContractId", contractId]);
      };
    }, []);
  if (!isLoadingTemplate && !contractTemplateData && contractTemplateError) {
    toast.error(contractTemplateError.message, {
      id: "error",
    });
    history.goBack();
  }
  if (
    !isLoadingTemplate &&
    contractTemplateData &&
    BasicDetails.ContractDetails.length === 0
  ) {
    let tempData = { ...BasicDetails };
    tempData["Date"] = parseCalendarDateToLocalDate(contractTemplateData.date);
    tempData["BusinessLegalName"] = contractTemplateData.businessLegalName;
    tempData["Position"] = contractTemplateData.position;
    tempData["OfficeAddress"] = contractTemplateData.officeAddress;
    tempData["LengthOfEmployment"] = contractTemplateData.lengthOfEmployment;
    tempData["StartOfWorkDate"] = parseCalendarDateToLocalDate(
      contractTemplateData.startOfWorkDate
    );
    tempData["EndOfWorkDate"] = contractTemplateData.endOfWorkDate
      ? parseCalendarDateToLocalDate(contractTemplateData.endOfWorkDate)
      : null;
    tempData["EmployeeName"] = contractTemplateData.employeeName;
    tempData["EmployeeAddress"] = contractTemplateData.employeeAddress;
    tempData["Salary"] = contractTemplateData.salary;
    tempData["ContractDetails"] = contractTemplateData.contractDetails;
    tempData["commission"] = contractTemplateData?.commission || "";
    tempData["bonus"] = contractTemplateData?.bonus || "";
    if (
      contractTemplateData.contractDetails[0] &&
      contractTemplateData.contractDetails[0].templateType
    ) {
      setDesignationType(contractTemplateData.contractDetails[0].templateType);
    }
    setBasicDetails(tempData);
  }
  const goBack = () => history.goBack();

  const exportContract = async () => {
    setPdfLoader(true);
    try {
      const resp = await getContractTemplatePdf(contractId);
      if (resp) {
        const blob = b64toBlob(resp, "application/pdf");
        if (isMobileTab()) {
          FileSaver.saveAs(blob);
        } else {
          const blobUrl = URL.createObjectURL(blob);
          const pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" + blobUrl + "'></iframe>"
          );
          pdfWindow.document.close();
        }
      }
      setPdfLoader(false);
    } catch (e) {
      setPdfLoader(false);
    }
  };

  return (
    <Page onBack={goBack} title={t("contracts.yourContract")}>
      {(pdfLoader || isLoadingOfficeDetail || isLoadingTemplate) && <Loader />}

      <div className="container container-smd p-0">
        <Text size="14px" color="#000" weight="300">
          {officeDetail && officeDetail.name ? officeDetail.name : ""}
        </Text>
        {!signContract && (
          <div>
            <div className={styles["contract-step-form"]}>
              {designationType === 1 ? (
                <PreviewPersonnelContract
                  officeDetail={officeDetail}
                  contractData={BasicDetails}
                  contractFormDisplayData={contractFormDisplayData}
                  contractDetails={contractTemplateData}
                />
              ) : (
                <PreviewAssociateContract
                  officeDetail={officeDetail}
                  contractData={BasicDetails}
                  contractFormDisplayData={contractFormDisplayData}
                  contractDetails={contractTemplateData}
                />
              )}
            </div>

            <div className="prev-next-buttons">
              <div>
                <button
                  className="button button-round button-border button-dark"
                  style={{ display: "none" }}
                ></button>
              </div>

              {contractTemplateData && contractTemplateData.status === 2 ? (
                <div className="next-step-col">
                  <div
                    className="link-btn cancel-btn"
                    onClick={() => {
                      exportContract();
                    }}
                  >
                    {t("contracts.exportEmploymentContract")}
                  </div>
                  <button
                    className="button button-shadow button-round"
                    onClick={() => {
                      setSignContract(true);
                    }}
                  >
                    {t("contracts.signEmploymentContract")}
                  </button>
                </div>
              ) : (
                <div className="next-step-col">
                  <button
                    className="button button-round"
                    onClick={() => {
                      exportContract();
                    }}
                  >
                    {t("contracts.exportEmploymentContract")}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {signContract && (
          <div className={styles["contract-step-form"]}>
            <Text size="18px" color="#111b45" weight="600" marginBottom="30px">
              {t("contracts.agreeStaffTermsAndConditions")}
            </Text>
            <SignContractForm
              contractId={contractId}
              setSignContract={setSignContract}
            />
          </div>
        )}
      </div>
    </Page>
  );
}

export default withTranslation()(ViewContract);
